// client/src/components/admin/influencer/InfluencerInfoSummary.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function InfluencerInfoSummary({ refreshToken }) {
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken]);

  const fetchCount = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/admin/influencer/info/count`, {
        credentials: 'include'
      });
      const result = await res.json();
      
      if (result.ok) {
        setCount(result.count || 0);
      } else {
        setError('불러오기 실패');
      }
    } catch (err) {
      console.error('fetchCount error:', err);
      setError('불러오기 실패');
    }
    setLoading(false);
  };

  return (
    <div className="influencer-info-summary">
      <h2 className="influencer-info-summary__title">인플루언서 정보관리</h2>
      <div className="influencer-info-summary__box">
        {error && <div className="influencer-info-summary__error">{error}</div>}
        {loading && <div className="influencer-info-summary__loading">불러오는 중...</div>}
        {!loading && !error && (
          <div className="influencer-info-summary__stats">
            <div className="influencer-info-summary__stat-text">
              총 <span className="influencer-info-summary__stat-number">{count}</span>명의
            </div>
            <div className="influencer-info-summary__stat-text">
              인플루언서가 활동중입니다.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default InfluencerInfoSummary;

